import React, { useCallback } from 'react';
import { citationAction, resolveCitationBinding } from '../../../projection/timeline/citationBindings.js';

const PREFIX = '#flare-evidence-';
const PROTECTED_TAGS = new Set(['code', 'pre']);
const LINKS = /(\[(?:\\.|[^\]\\])*\]\(#flare-evidence-[^\s)]+\))/g;
const LINK = /^\[((?:\\.|[^\]\\])*)\]\((#flare-evidence-[^\s)]+)\)$/;

const fromHref = (href, payload) => {
  try { return resolveCitationBinding(payload, decodeURIComponent(href.slice(PREFIX.length))); }
  catch { return null; }
};

/** Render prepared links only; the backend supplies identity, reading and anchor. */
export function CitationLink({ href = '', children, citationPayload, onAction, themeTokens = {}, ...props }) {
  const citation = fromHref(href, citationPayload);
  const open = useCallback(() => { if (citation) onAction?.(citationAction(citation)); }, [citation, onAction]);
  if (!href.startsWith(PREFIX)) return <a {...props} href={href}>{children}</a>;
  if (!citation) return children;
  return <button type="button" className="flare-inline-evidence-citation" aria-label={`读取 ${citation.title}`}
    onClick={open} style={{ padding: 0, border: 0, borderBottom: '1px dotted currentColor', background: 'transparent',
      font: 'inherit', cursor: 'pointer', color: themeTokens.textSecondary ?? 'inherit' }}>{children}</button>;
}

const renderText = (text, options) => text.split(LINKS).map((part, index) => {
  const match = part.match(LINK);
  if (!match) return part;
  return <CitationLink key={`citation-${index}`} {...options} href={match[2]}>
    {match[1].replace(/\\([\\[\]*_`])/g, '$1')}</CitationLink>;
});

/** Share reference App's inline-link translation across blocks; code/pre stay literal. */
export const renderCitationNodes = (node, options = {}) => {
  if (Array.isArray(node)) return node.map(child => renderCitationNodes(child, options));
  if (typeof node === 'string') return renderText(node, options);
  if (!React.isValidElement(node) || PROTECTED_TAGS.has(node.type) || !node.props.children) return node;
  return React.cloneElement(node, {}, renderCitationNodes(node.props.children, options));
};
